import React from 'react';
import { Brush, CheckCircle, Clock, AlertTriangle, Package, Search, ArrowBigLeft, Upload, X } from 'lucide-react';
import '../../../../../styles/components/vehicle-register.scss';
import { toast } from 'react-toastify';
import i18n from '../../../../../i18n';
import { formatDate } from '../../../../../utils/common';

class CleaningSchedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // Cleaning Ticket Information
            cleaningId: 'CLN-' + Date.now().toString().slice(-6),
            cleaningDate: new Date().toISOString().split('T')[0],
            cleaningTime: new Date().toTimeString().slice(0, 5),
            cleaningStatus: 'pending', // 'pending', 'in-progress', 'completed', 'cancelled'

            // Related Loading Ticket
            relatedTicketId: '',
            vehicleNumber: '',
            driverName: '',
            materialType: '',

            // Cleaning Details
            cleaningType: 'yard', // 'yard', 'vehicle', 'weighbridge', 'facility'
            areaLocation: '',
            cleaningSupervisor: '',
            cleaningTeam: [],

            // Cleaning Checklist
            checklist: {
                debris_removed: false,
                spillage_cleaned: false,
                area_swept: false,
                waste_disposed: false,
                equipment_cleaned: false,
                Safety_checked: false
            },

            // Waste Information
            wasteType: '',
            wasteQuantity: '',
            wasteDisposalMethod: 'recycling', // 'recycling', 'landfill', 'incineration'
            disposalCertificate: '',

            // Inspection Results
            inspectionStatus: 'pending', // 'pending', 'passed', 'failed'
            inspectionNotes: '',
            inspectorName: '',
            inspectionDate: '',

            // Photos
            beforePhotos: [],
            afterPhotos: [],

            // Timing Information
            cleaningStartTime: '',
            cleaningEndTime: '',
            cleaningDuration: '',


            auctions: [
                {
                    id: 1,
                    cleaningId: 'CLN-001',
                    relatedTicketId: 'TKT-002',
                    name: 'MIXED SCRAP',
                    vehicleNumber: '6650 HM',
                    driverName: 'SHAZAD HUSSAIN',
                    materialType: 'aluminum',
                    cleaningType: 'yard',
                    areaLocation: 'NIMR LOGISTIC AUCTION YARD-01',
                    cleaningStatus: 'completed',
                    cleaningDate: '2025-02-08',
                    inspectionStatus: 'passed',
                    wasteQuantity: '2.5'
                },
                {
                    id: 2,
                    name: 'SITE 2',
                    cleaningId: 'CLN-002',
                    relatedTicketId: 'TKT-004',
                    vehicleNumber: '2174 DA',
                    driverName: 'ARSHAD ALI',
                    materialType: 'steel',
                    cleaningType: 'weighbridge',
                    areaLocation: 'NIMR - BILLAD MAAJAN WEIGH BRIDGE',
                    cleaningStatus: 'completed',
                    cleaningDate: '2025-02-08',
                    inspectionStatus: 'passed',
                    wasteQuantity: '1.2'
                },
                {
                    id: 3,
                    name: 'SITE 3',
                    cleaningId: 'CLN-003',
                    relatedTicketId: 'TKT-007',
                    vehicleNumber: '4592 MN',
                    driverName: 'AHMED HASSAN',
                    materialType: 'batteries',
                    cleaningType: 'vehicle',
                    areaLocation: 'NIMR BATTERY STORAGE YARD',
                    cleaningStatus: 'in-progress',
                    cleaningDate: '2025-02-09',
                    inspectionStatus: 'in-progress',
                    wasteQuantity: '0.8'
                },
                {
                    id: 4,
                    name: 'SITE 4',
                    cleaningId: 'CLN-004',
                    relatedTicketId: 'TKT-009',
                    vehicleNumber: '8912 RT',
                    driverName: 'FARHAN KHAN',
                    materialType: 'mixed-scrap',
                    cleaningType: 'facility',
                    areaLocation: 'RIMA MIXED SCRAP YARD',
                    cleaningStatus: 'in-progress',
                    cleaningDate: '2025-02-09',
                    inspectionStatus: 'in-progress',
                    wasteQuantity: ''
                }, {
                    id: 5,
                    name: 'SITE 5',
                    cleaningId: 'CLN-004',
                    relatedTicketId: 'AREA-2',
                    vehicleNumber: 'AREA-2',
                    driverName: 'FARHAN KHAN',
                    materialType: 'mixed-scrap',
                    cleaningType: 'facility',
                    areaLocation: 'RIMA MIXED SCRAP YARD',
                    cleaningStatus: 'in-progress',
                    cleaningDate: '2025-02-09',
                    inspectionStatus: 'in-progress',
                    wasteQuantity: ''
                }
            ],


            // Recent Cleaning Records
            recentCleanings: [
                {
                    id: 1,
                    cleaningId: 'CLN-001',
                    relatedTicketId: 'TKT-002',
                    vehicleNumber: 'FUHAD SITE 2',
                    driverName: 'SHAZAD HUSSAIN',
                    materialType: 'aluminum',
                    cleaningType: 'yard',
                    areaLocation: 'NIMR LOGISTIC AUCTION YARD-01',
                    cleaningStatus: 'completed',
                    cleaningDate: '2025-02-08',
                    inspectionStatus: 'passed',
                    wasteQuantity: '2.5'
                },
                {
                    id: 2,
                    cleaningId: 'CLN-002',
                    relatedTicketId: 'TKT-004',
                    vehicleNumber: 'FUHAD SITE 3',
                    driverName: 'ARSHAD ALI',
                    materialType: 'steel',
                    cleaningType: 'weighbridge',
                    areaLocation: 'NIMR - BILLAD MAAJAN WEIGH BRIDGE',
                    cleaningStatus: 'completed',
                    cleaningDate: '2025-02-08',
                    inspectionStatus: 'passed',
                    wasteQuantity: '1.2'
                },
                {
                    id: 3,
                    cleaningId: 'CLN-003',
                    relatedTicketId: 'AREA',
                    vehicleNumber: 'FUHAD SITE 5',
                    driverName: 'AHMED HASSAN',
                    materialType: 'batteries',
                    cleaningType: 'vehicle',
                    areaLocation: 'NIMR BATTERY STORAGE YARD',
                    cleaningStatus: 'in-progress',
                    cleaningDate: '2025-02-09',
                    inspectionStatus: 'in-progress',
                    wasteQuantity: '0.8'
                },
                {
                    id: 4,
                    cleaningId: 'CLN-004',
                    relatedTicketId: 'TKT-009',
                    vehicleNumber: 'RIMA MIXED SCRAP YARD',
                    driverName: 'FARHAN KHAN',
                    materialType: 'mixed-scrap',
                    cleaningType: 'facility',
                    areaLocation: 'RIMA MIXED SCRAP YARD',
                    cleaningStatus: 'in-progress',
                    cleaningDate: '2025-02-09',
                    inspectionStatus: 'in-progress',
                    wasteQuantity: ''
                }, {
                    id: 5,
                    cleaningId: 'CLN-004',
                    relatedTicketId: 'TKT-009',
                    vehicleNumber: '8912 RT',
                    driverName: 'FARHAN KHAN',
                    materialType: 'mixed-scrap',
                    cleaningType: 'facility',
                    areaLocation: 'RIMA MIXED SCRAP YARD',
                    cleaningStatus: 'in-progress',
                    cleaningDate: '2025-02-09',
                    inspectionStatus: 'in-progress',
                    wasteQuantity: ''
                }
            ],

            // Search
            searchQuery: '',
            errors: {}
        };
    }

    // Handle input changes
    handleInputChange = (field, value) => {
        this.setState({
            [field]: value,
            errors: { ...this.state.errors, [field]: '' }
        });
    };

    // Handle checklist changes
    handleChecklistChange = (item) => {
        this.setState(prevState => ({
            checklist: {
                ...prevState.checklist,
                [item]: !prevState.checklist[item]
            }
        }));
    };

    // Handle related ticket selection
    handleTicketSelect = (ticket) => {
        this.setState({
            relatedTicketId: ticket.ticketNumber,
            vehicleNumber: ticket.vehicleNumber,
            driverName: ticket.driverName,
            materialType: ticket.materialType,
            areaLocation: ticket.yardLocation || ticket.weighbridgeLocation
        });
    };

    // Start cleaning process
    startCleaning = () => {
        const { relatedTicketId, areaLocation } = this.state;

        if (!relatedTicketId) {
            toast.error('Please select a related loading ticket');
            return;
        }

        if (!areaLocation) {
            toast.error('Please specify the cleaning area location');
            return;
        }

        this.setState({
            cleaningStatus: 'in-progress',
            cleaningStartTime: new Date().toISOString()
        });

        toast.success('Cleaning process started!');
    };

    // Complete cleaning process
    completeCleaning = () => {
        const { checklist, wasteType, wasteQuantity } = this.state;

        // Validate required fields
        const requiredChecklistItems = ['debrisRemoved', 'spillageCleaned', 'areaSwept', 'wasteDisposed'];
        const allRequiredCompleted = requiredChecklistItems.every(item => checklist[item]);

        if (!allRequiredCompleted) {
            toast.error('Please complete all required cleaning tasks');
            return;
        }

        if (!wasteType || !wasteQuantity) {
            toast.error('Please provide waste information');
            return;
        }

        this.setState({
            cleaningStatus: 'completed',
            cleaningEndTime: new Date().toISOString(),
            cleaningDuration: this.calculateCleaningDuration()
        });

        toast.success('Cleaning process completed! Ready for inspection.');
    };

    // Calculate cleaning duration
    calculateCleaningDuration = () => {
        const { cleaningStartTime, cleaningEndTime } = this.state;

        if (!cleaningStartTime || !cleaningEndTime) return '';

        const start = new Date(cleaningStartTime);
        const end = new Date(cleaningEndTime);
        const durationMs = end - start;
        const minutes = Math.round(durationMs / (1000 * 60));

        return `${minutes} minutes`;
    };

    // Handle inspection
    handleInspection = (status) => {
        this.setState({
            inspectionStatus: status,
            inspectorName: 'Current User', // Replace with actual user
            inspectionDate: new Date().toISOString()
        });

        const message = status === 'passed' ? 'Area inspection passed!' : 'Area inspection failed - review required';
        toast[status === 'passed' ? 'success' : 'warning'](message);
    };

    // Add photo
    addPhoto = (type, file) => {
        // In a real app, you would upload the file and get a URL
        const newPhoto = {
            id: Date.now(),
            url: URL.createObjectURL(file),
            type: type,
            timestamp: new Date().toISOString()
        };

        if (type === 'before') {
            this.setState(prevState => ({
                beforePhotos: [...prevState.beforePhotos, newPhoto]
            }));
        } else {
            this.setState(prevState => ({
                afterPhotos: [...prevState.afterPhotos, newPhoto]
            }));
        }
    };

    // Remove photo
    removePhoto = (type, id) => {
        if (type === 'before') {
            this.setState(prevState => ({
                beforePhotos: prevState.beforePhotos.filter(photo => photo.id !== id)
            }));
        } else {
            this.setState(prevState => ({
                afterPhotos: prevState.afterPhotos.filter(photo => photo.id !== id)
            }));
        }
    };

    // Get filtered recent cleanings
    getFilteredCleanings = () => {
        const { recentCleanings, searchQuery } = this.state;
        if (!searchQuery) return recentCleanings;

        return recentCleanings.filter(cleaning =>
            cleaning.vehicleNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cleaning.driverName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cleaning.cleaningId.toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    // Reset form
    resetForm = () => {
        this.setState({
            cleaningId: 'CLN-' + Date.now().toString().slice(-6),
            cleaningDate: new Date().toISOString().split('T')[0],
            cleaningTime: new Date().toTimeString().slice(0, 5),
            cleaningStatus: 'pending',
            relatedTicketId: '',
            vehicleNumber: '',
            driverName: '',
            materialType: '',
            cleaningType: 'yard',
            areaLocation: '',
            cleaningSupervisor: '',
            cleaningTeam: [],
            checklist: {
                debrisRemoved: false,
                spillageCleaned: false,
                areaSwept: false,
                wasteDisposed: false,
                equipmentCleaned: false,
                safetyChecked: false
            },
            wasteType: '',
            wasteQuantity: '',
            wasteDisposalMethod: 'recycling',
            disposalCertificate: '',
            inspectionStatus: 'pending',
            inspectionNotes: '',
            inspectorName: '',
            inspectionDate: '',
            beforePhotos: [],
            afterPhotos: [],
            cleaningStartTime: '',
            cleaningEndTime: '',
            cleaningDuration: '',
            errors: {}
        });
    };

    render() {
        const {
            cleaningId,
            cleaningStatus,
            relatedTicketId,
            vehicleNumber,
            materialType,
            cleaningType,
            areaLocation,
            checklist,
            wasteQuantity,
            inspectionStatus,
            inspectionNotes,
            cleaningStartTime,
            cleaningEndTime,
            searchQuery,
            errors,
            wasteType ,
            beforePhotos,
            afterPhotos
        } = this.state;

        const filteredCleanings = this.getFilteredCleanings();
        const isCleaningInProgress = cleaningStatus === 'in-progress';
        const isCleaningCompleted = cleaningStatus === 'completed';

        return (
            <main className="main-content card">
                <div className="page-header">
                    <button className="button1 button1-primary" onClick={() => window.history.back()}>
                        <ArrowBigLeft /> {i18n.t('dashboard')}
                    </button>

                    <div className="page-title">
                        <h1>{i18n.t('cleaning_schedule')}</h1>
                    </div>

                    <div className="header-actions">
                        <button className="button1 button1-secondary" onClick={this.resetForm}>
                            New Cleaning
                        </button>
                        {cleaningStatus === 'pending' && (
                            <button className="button1 button1-primary" onClick={this.startCleaning}>
                                Start Cleaning
                            </button>
                        )}
                        {isCleaningInProgress && (
                            <button className="button1 button1-primary" onClick={this.completeCleaning}>
                                Complete Cleaning
                            </button>
                        )}
                    </div>
                </div>

                {/* {/*    */}
                <div className="content-grid">

                    <div className="right-column">
                        <section className="card-t1">
                            <div className="form-group full-width section-divider">
                                <div className="card-t1-header">
                                    <Clock size={24} className="header-icon" />
                                    <h2>Recent Cleaning Records</h2>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="search-box">
                                    <Search size={16} />
                                    <input
                                        type="text"
                                        placeholder="Search by site or cleaning ID..."
                                        value={searchQuery}
                                        onChange={(e) => this.handleInputChange('searchQuery', e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="transactions-list-container">
                                <div className="transactions-list">
                                    {filteredCleanings.map(cleaning => (
                                        <div
                                            key={cleaning.id}
                                            className={`transaction-item ${relatedTicketId === cleaning.relatedTicketId ? 'active' : ''}`}
                                            onClick={() => this.handleTicketSelect(cleaning)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="transaction-header">
                                                <span className="vehicle-number">
                                                    {/* {cleaning.vehicleNumber} */}
                                                    <strong className="transaction">{cleaning.cleaningId}</strong>
                                                </span>
                                                <span className={`status-badge ${cleaning.cleaningStatus}`}>
                                                    {cleaning.cleaningStatus}
                                                </span>
                                            </div>
                                            <div className="transaction-details">
                                                {cleaning.areaLocation}

                                            </div>
                                            <div className="transaction-hover">Click to load this record</div>
                                        </div>
                                    ))}
                                    {filteredCleanings.length === 0 && (
                                        <div className="no-results">No cleaning records found</div>
                                    )}
                                </div>
                            </div>
                        </section>

                        <section className="card-t1">
                            <div className="form-group full-width section-divider">
                                <div className="card-t1-header">
                                    <Package size={24} className="header-icon" />
                                    <h2>Cleaning Summary</h2>
                                </div>
                            </div>

                            <div className="operation-summary">
                                <div className="summary-item">
                                    <span className="label">Cleaning ID:</span>
                                    <span className="value">{cleaningId}</span>
                                </div>
                                <div className="summary-item">
                                    <span className="label">Status:</span>
                                    <span className={`value ${cleaningStatus}`}>{cleaningStatus}</span>
                                </div>
                                <div className="summary-item">
                                    <span className="label">Vehicle:</span>
                                    <span className="value">{vehicleNumber || 'Not specified'}</span>
                                </div>
                                <div className="summary-item">
                                    <span className="label">Area:</span>
                                    <span className="value">{areaLocation || 'Not specified'}</span>
                                </div>
                                <div className="summary-item">
                                    <span className="label">Inspection:</span>
                                    <span className={`value ${inspectionStatus}`}>{inspectionStatus}</span>
                                </div>
                                {wasteQuantity && (
                                    <div className="summary-item">
                                        <span className="label">Waste Collected:</span>
                                        <span className="value">{wasteQuantity} kg</span>
                                    </div>
                                )}
                            </div>
                        </section>
                    </div>


                    <section className="card-t1 cleaning-details">
                        <div className="form-grid">
                            <div className="form-group full-width">
                                <div className="section-header section-divider">
                                    <div className="card-t1-header">
                                        <Brush size={24} className="header-icon" />
                                        <h2>Cleaning Information</h2>
                                    </div>
                                    <div className={`status-badge large ${cleaningStatus}`}>
                                        {cleaningStatus}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="required">Area</label>
                                <select
                                    value={areaLocation}
                                    onChange={(e) => this.handleInputChange('areaLocation', e.target.value)}
                                    disabled={isCleaningInProgress || isCleaningCompleted}
                                >
                                    <option value="NMIR">NMIR</option>
                                    <option value="YIBAL">YIBAL</option>
                                    <option value="FUHAD">FUHAD</option>
                                </select>
                                {errors.areaLocation && <span className="error-message">{errors.areaLocation}</span>}

                            </div>


                            <div className="form-group">
                                <label className="required">Auction Sites</label>
                                <select
                                    value={relatedTicketId}
                                    onChange={(e) => {
                                        const ticket = this.state.auctions.find(c => c.name === e.target.value);
                                        if (ticket) this.handleTicketSelect(ticket);
                                    }}
                                    className={errors.relatedTicketId ? 'error' : ''}
                                    disabled={isCleaningInProgress || isCleaningCompleted}
                                >
                                    <option value="">Select a completed site</option>
                                    {this.state.auctions.map(auctions => (
                                        <option key={auctions.id} value={auctions.name}>
                                            {auctions.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.relatedTicketId && <span className="error-message">{errors.relatedTicketId}</span>}
                            </div>


                            <div className="form-group">
                                <label>Material Type</label>
                                <input
                                    type="text"
                                    value={materialType}
                                    readOnly
                                    className="readonly-input"
                                />
                            </div>

                            <div className="form-group">
                                <label className="required">Cleaning Type</label>
                                <select
                                    value={cleaningType}
                                    onChange={(e) => this.handleInputChange('cleaningType', e.target.value)}
                                    disabled={isCleaningInProgress || isCleaningCompleted}
                                >
                                    <option value="yard">Yard Cleaning</option>
                                    <option value="vehicle">Vehicle Cleaning</option>
                                    <option value="weighbridge">Weighbridge Cleaning</option>
                                    <option value="facility">Facility Cleaning</option>
                                </select>
                            </div>




                            {(
                                <div className="form-group full-width">
                                    <label className="required">Cleaning Checklist</label>
                                    <div className="checklist-grid">
                                        {Object.entries(checklist).map(([key, value]) => (
                                            <div
                                                key={key}
                                                className={`checklist-item ${value ? 'completed' : ''}`}
                                                onClick={() => this.handleChecklistChange(key)}
                                            >
                                                <div className="checklist-checkbox">
                                                    {value && <CheckCircle size={16} />}
                                                </div>
                                                <span className="checklist-label">
                                                    {i18n.t(key)}
                                                    {/* {key.split(/(?=[A-Z])/).join(' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase())} */}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            { (
                                <>
                                    <div className="form-group">
                                        <label className="required">Waste Type</label>
                                        <input
                                            type="text"
                                            placeholder="Type of waste collected"
                                            value={wasteType}
                                            onChange={(e) => this.handleInputChange('wasteType', e.target.value)}
                                            className={errors.wasteType ? 'error' : ''}
                                        />
                                        {errors.wasteType && <span className="error-message">{errors.wasteType}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label className="required">Waste Quantity (kg)</label>
                                        <input
                                            type="number"
                                            placeholder="Weight of waste"
                                            value={wasteQuantity}
                                            onChange={(e) => this.handleInputChange('wasteQuantity', e.target.value)}
                                            className={errors.wasteQuantity ? 'error' : ''}
                                            min="0"
                                            step="0.1"
                                        />
                                        {errors.wasteQuantity && <span className="error-message">{errors.wasteQuantity}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label>Disposal Method</label>
                                        <select
                                            value={this.state.wasteDisposalMethod}
                                            onChange={(e) => this.handleInputChange('wasteDisposalMethod', e.target.value)}
                                        >
                                            <option value="recycling">Recycling</option>
                                            <option value="landfill">Landfill</option>
                                            <option value="incineration">Incineration</option>
                                        </select>
                                    </div>
                                </>
                            )}

                            { (
                                <div className="form-group full-width">
                                    <label>Documentation Photos</label>

                                    <div className="photo-section">
                                        <h4>Before Cleaning</h4>
                                        <div className="photo-grid">
                                            {beforePhotos.map(photo => (
                                                <div key={photo.id} className="photo-item">
                                                    <img src={photo.url} alt="Before cleaning" />
                                                    <button
                                                        className="remove-photo"
                                                        onClick={() => this.removePhoto('before', photo.id)}
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                </div>
                                            ))}
                                            <div className="photo-upload">
                                                <Upload size={32} />
                                                <span>Add Before Photo</span>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => e.target.files[0] && this.addPhoto('before', e.target.files[0])}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="photo-section">
                                        <h4>After Cleaning</h4>
                                        <div className="photo-grid">
                                            {afterPhotos.map(photo => (
                                                <div key={photo.id} className="photo-item">
                                                    <img src={photo.url} alt="After cleaning" />
                                                    <button
                                                        className="remove-photo"
                                                        onClick={() => this.removePhoto('after', photo.id)}
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                </div>
                                            ))}
                                            <div className="photo-upload">
                                                <Upload size={32} />
                                                <span>Add After Photo</span>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => e.target.files[0] && this.addPhoto('after', e.target.files[0])}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isCleaningCompleted && (
                                <div className="form-group full-width">
                                    <div className="section-header section-divider">
                                        <h3>Area Inspection</h3>
                                        <div className={`status-badge ${inspectionStatus}`}>
                                            {inspectionStatus}
                                        </div>
                                    </div>

                                    <div className="inspection-actions">
                                        <button
                                            className="btn-success"
                                            onClick={() => this.handleInspection('passed')}
                                            disabled={inspectionStatus === 'passed'}
                                        >
                                            <CheckCircle size={16} />
                                            Pass Inspection
                                        </button>
                                        <button
                                            className="btn-warning"
                                            onClick={() => this.handleInspection('failed')}
                                            disabled={inspectionStatus === 'failed'}
                                        >
                                            <AlertTriangle size={16} />
                                            Fail Inspection
                                        </button>
                                    </div>

                                    <div className="form-group">
                                        <label>Inspection Notes</label>
                                        <textarea
                                            placeholder="Additional inspection comments..."
                                            value={inspectionNotes}
                                            onChange={(e) => this.handleInputChange('inspectionNotes', e.target.value)}
                                            rows="3"
                                        />
                                    </div>
                                </div>
                            )}

                            {(cleaningStartTime || cleaningEndTime) && (
                                <div className="form-group full-width">
                                    <div className="timing-info">
                                        {cleaningStartTime && (
                                            <div className="timing-item">
                                                <span className="label">Started:</span>
                                                <span className="value">{formatDate(cleaningStartTime)}</span>
                                            </div>
                                        )}
                                        {cleaningEndTime && (
                                            <div className="timing-item">
                                                <span className="label">Completed:</span>
                                                <span className="value">{formatDate(cleaningEndTime)}</span>
                                            </div>
                                        )}
                                        {this.state.cleaningDuration && (
                                            <div className="timing-item">
                                                <span className="label">Duration:</span>
                                                <span className="value">{this.state.cleaningDuration}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
                {/*  */}
            </main>
        );
    }
}

export default CleaningSchedule;